import IndigoMessage from './IndigoMessage';

export enum IndigoInternalMessageType {
    SERVER_CHANGED = 'SERVER_CHANGED',
}

export const InternalDestination = 'INIT';

export type IndigoServerChangedMessage = IndigoMessage<{
    type: IndigoInternalMessageType.SERVER_CHANGED;
    server: string;
}>;

export type IndigoInternalMessage = IndigoServerChangedMessage;
